import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class ItistateapiService {

//  public SERVER_BASEURL = "http://localhost:5001/";
// public SERVER_BASEURL = "https://grsnodetest.nimiquestionbank.in/";
public SERVER_BASEURL = "https://nodetest.nimiquestionbank.in/";

public SERVER_BASEURL11 = "https://api.ncvtmis.gov.in/nimi/api/getTrainees/";
public SERVER_BASEURL1 = "https://api.ncvtmis.gov.in/nimi/api/getITIOnStateCode/";
//public SERVER_BASEURL2= "https://api.ncvtmis.gov.in/nimi/api/UploadTraineeRegNumbers/";
// public SERVER_BASEURL11 = "https://164.100.213.13/api/getTrainees/";
// public SERVER_BASEURL1 = "https://164.100.213.13/api/getITIOnStateCode/";
// //public SERVER_BASEURL2= "https://164.100.213.13/api/UploadTraineeRegNumbers/";
public SERVER_BASEURL2 = "https://nimionlineadmission.in/dgt/upload_api.php";
public ccref_url = "https://nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenue.php?ccav=";
public ccref_url11 = "http://192.168.0.159/nimi_projects/SSW/ccavanue.php";
public ccrefupdate_url =  "https://www.nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenuefull.php?ccav=";

// ('https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=' . $mobile . '&sid=NIMIAP&msg=Your%20OTP%20is%20'.$otp.'%20for%20reference%20number%20'.$regno.'%20-%20NIMI&fl=0&gwid=2')
//9442507934
public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your%20OTP%20is%20'+'77777'+'%20for%20reference%20number%20'+22222+'%20-%20NIMI&fl=0&gwid=2';

// public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your OTP Number is '+9999+' for reference number '+'NAN123456'+'- NIMI&fl=0&gwid=2';



constructor(private httpClient: HttpClient) { }


statecheckuserid(args: any) {
    this.cc_mob;

    return this.httpClient.post(this.SERVER_BASEURL + "statecheckuserid/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
}

statecheckOtp(args: any) {

    

  return this.httpClient.post(this.SERVER_BASEURL + "statecheckOtp/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

statecheck(args: any) {

    

  return this.httpClient.post(this.SERVER_BASEURL + "statecheck/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

listITIstate() {
  return this.httpClient.get(this.SERVER_BASEURL + "listITIstate/").pipe(
    map((data) => {
      //alert(data);
      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

importITITableAlldata(args: any) {

  return this.httpClient.post(this.SERVER_BASEURL + "importITITableAlldata/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

// Statesearch(q: any) {
//   alert(JSON.stringify(q))
//   let promise = new Promise((resolve, reject) => {
//     let apiURL = this.SERVER_BASEURL1+q.iticode;
//     this.httpClient.get(apiURL)
//         .toPromise()
//         .then(
//             res => { // Success
//               resolve(res);
              
//             },
//             msg => { // Error
//               reject(msg);
//             }
//         );
//   });
//   return promise;
// }

Statesearch(args: any) {
  const headers = new HttpHeaders({
    "Content-Type": 'application/json;charset=utf-8',
    // 'Content-Type': 'application/json',
    //'Accept': 'application/json',
    //'Access-Control-Allow-Headers': 'Content-Type',
    //'Access-Control-Allow-Headers': '*',
    "loginid": 'NIMI_TraineeDetails',
    "key_spec": 'qiK3aZ4eeeoBZoUlBqSzpA=='
    
  });

  
 alert(this.SERVER_BASEURL1+args.iticode);
  
  return this.httpClient.get(this.SERVER_BASEURL1+args.statekey,  { headers: headers }).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );

  // return new Promise((resolve, reject) => {
  //   this.http.post<PostReturn>(`${environment.apiurl}` + '/api/auth/login',
  //     { username: username, password: password }, { headers: headers }).subscribe(
  //       data => {
  //         resolve(data);
  //       }, (err: HttpErrorResponse) => {
  //         reject(err)
  //       });
  // });
}

  checkITIApiTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "checkITIApiTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listITIstateKey(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "listITIstateKey/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  importITITableAll(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "importITITableAll/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showStateItiTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "showStateItiTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showItiTableLimitCount(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "showItiTableLimitCount/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checkITIApi(args: any) {
    const headers = new HttpHeaders({
      "Content-Type": 'application/json;charset=utf-8',
      // 'Content-Type': 'application/json',
      //'Accept': 'application/json',
      //'Access-Control-Allow-Headers': 'Content-Type',
      //'Access-Control-Allow-Headers': '*',
      "loginid": 'NIMI_TraineeDetails',
      "key_spec": 'qiK3aZ4eeeoBZoUlBqSzpA=='
      
    });    
    
    return this.httpClient.get(this.SERVER_BASEURL11+args,  { headers: headers }).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );

    // return new Promise((resolve, reject) => {
    //   this.http.post<PostReturn>(`${environment.apiurl}` + '/api/auth/login',
    //     { username: username, password: password }, { headers: headers }).subscribe(
    //       data => {
    //         resolve(data);
    //       }, (err: HttpErrorResponse) => {
    //         reject(err)
    //       });
    // });
  }

  getUpdateTraineeData(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "getUpdateTraineeData/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showStateItiCountTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "showStateItiCountTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showStateItiDistrictTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "showStateItiDistrictTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  importStateTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "importStateTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  importStateOfflineTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "importStateOfflineTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  

  importOfflineForm(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "importOfflineForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  updateStateSelectTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "updateStateSelectTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showStateItiMasterTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "showStateItiMasterTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = `${error.error.message}`;
    } else {
      // server-side error
      //errorMessage = `${error.status} <br /> Message: ${error.message}`;
      errorMessage = `Server Error<br /> Message: ${error.message}`;
    }

    return throwError(errorMessage);
  }

}
